import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "source", "revealable"]
  static values = {
    field: String,
    showValues: { type: Array, default: [] }
  }

  connect() {
    this.toggle()
  }

  toggle() {
    // Mode 1: source/revealable targets — show revealable when source has a value
    if (this.hasSourceTarget && this.hasRevealableTarget) {
      const hasValue = this.sourceTarget.value !== ""
      this.revealableTargets.forEach(el => {
        el.style.display = hasValue ? "" : "none"
      })
      return
    }

    // Mode 2: field/showValues — show section when field matches showValues
    const field = this.element.querySelector(`[data-progressive-reveal-field="${this.fieldValue}"]`) ||
                  this.element.querySelector(`[name="${this.fieldValue}"]`)
    if (!field) return

    const value = field.value
    const shouldShow = this.showValuesValue.includes(value)

    this.sectionTargets.forEach(section => {
      section.classList.toggle("hidden", !shouldShow)
    })
  }

  change() {
    this.toggle()
  }
}
